// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'RobotoMedium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: 500;
}

@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
    font-weight: 400;
}

.overlay {
    position: absolute;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    transition-property: background-color;
    transition-timing-function: ease-in-out;
    transition-duration: 250ms;
    z-index: 1;
}

.overlay-text {
    font-size: 18px;
    font-family: 'Roboto', system-ui;
    color: #ffffff;
    opacity: 0;
}

.studio-link-text {
    font-family: 'RobotoMedium', system-ui;
    margin-right: 4px;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
}

.top-right-button {
    position: absolute;
    top: 0;
    right: 0;
    display: none;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    z-index: 10;
    cursor: pointer;
    width: 20px;
    height: 20px;
    border-radius: 0 0 0 3px;
    border: 1px solid #e1e1e1;
    border-top-width: 0px;
    border-right-width: 0px;
}

.top-right-button:hover {
    background-color: #f7f7f7;
}

.studio-link-button {
    width: 60px;
    margin-right: 3px;
    border-radius: 0 0 3px 3px;
    right: 20px;
}

.studio-link-button-right {
    border-radius: 0 0 0 3px;
    right: 0;
    margin: 0;
}

.top-right-button-icon {
    width: 12px;
    height: 12px;
    fill: #4a4a4a;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,+DAAwD;IACxD,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,+DAAyD;IACzD,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,uCAAuC;IACvC,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,cAAc;IACd,UAAU;AACd;;AAEA;IACI,sCAAsC;IACtC,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,yBAAyB;IACzB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB","sourcesContent":["@font-face {\n    font-family: 'RobotoMedium';\n    src: url('./fonts/Roboto-Medium.ttf') format('truetype');\n    font-weight: 500;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('./fonts/Roboto-Regular.ttf') format('truetype');\n    font-weight: 400;\n}\n\n.overlay {\n    position: absolute;\n    top: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    transition-property: background-color;\n    transition-timing-function: ease-in-out;\n    transition-duration: 250ms;\n    z-index: 1;\n}\n\n.overlay-text {\n    font-size: 18px;\n    font-family: 'Roboto', system-ui;\n    color: #ffffff;\n    opacity: 0;\n}\n\n.studio-link-text {\n    font-family: 'RobotoMedium', system-ui;\n    margin-right: 4px;\n    font-size: 12px;\n    line-height: 14px;\n    font-weight: 500;\n}\n\n.top-right-button {\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: none;\n    justify-content: center;\n    align-items: center;\n    background-color: #fff;\n    z-index: 10;\n    cursor: pointer;\n    width: 20px;\n    height: 20px;\n    border-radius: 0 0 0 3px;\n    border: 1px solid #e1e1e1;\n    border-top-width: 0px;\n    border-right-width: 0px;\n}\n\n.top-right-button:hover {\n    background-color: #f7f7f7;\n}\n\n.studio-link-button {\n    width: 60px;\n    margin-right: 3px;\n    border-radius: 0 0 3px 3px;\n    right: 20px;\n}\n\n.studio-link-button-right {\n    border-radius: 0 0 0 3px;\n    right: 0;\n    margin: 0;\n}\n\n.top-right-button-icon {\n    width: 12px;\n    height: 12px;\n    fill: #4a4a4a;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
